import Carson1 from '../../../media/Residentials/Carson/Carson.webp'
import Carson2 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson3 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson4 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson5 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson6 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson7 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson8 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson9 from '../../../media/Residentials/Carson/Carson (1).webp'
import Carson10 from '../../../media/Residentials/Carson/Carson (10).webp'

const Carsonimages =[
Carson1,Carson2,Carson3,Carson4,Carson5,Carson6,Carson7,Carson8,Carson9,Carson10
]

export default Carsonimages;